import React from 'react'
import styled from '@emotion/styled'
import { DoubleNavbar, SettingsIcon, SidebarItem, ToolbarHeader } from '@labsavvyapp/components'
import { useHistory } from 'react-router'
import { SETTINGS } from '../../../config/routes'
import { CreateOrdersetHeaderControls, EditOrdersetHeaderControls, OrdersetListHeaderControls } from '../OrdersetSettingsPage/view'
import { ProfileHeaderControls } from '../ProfileSettingsPage/view'
import { BillingHeaderControls } from '../BillingSettingsPage/view'
import { useQueryGetMeApi } from '../../../viewmodels/user/api/useQueryGetMe.api'

const SettingsPageLayoutViewLayout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  height: 100%;
`

const ComponentLayout = styled.div`
  display: grid;
  grid-template-columns: 192px 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;
  margin-top: 5px;
  width: 99%;
  height: 100%;
`
interface ComponentProps extends React.ComponentProps<any> { }

export const SettingsPageLayout: React.FunctionComponent<ComponentProps> = (props: ComponentProps) => {
  const { push, location } = useHistory()
  const { data: meData, loading: meLoading } = useQueryGetMeApi()


  const requireStripeAccount = (meData as any)?.getMe?.partner?.config?.ordering?.require_stripe_account ?? false

  const allMenuItems = [
    {
      title: 'Orderset Settings ',
      icon: <SettingsIcon />,
      url: SETTINGS.orderset,
      active: true,
      visible: true,
    },
    {
      title: 'Profile Settings',
      icon: <SettingsIcon />,
      url: SETTINGS.profile,
      active: false,
      visible: true,
    },
    {
      title: 'Billing Settings',
      icon: <SettingsIcon />,
      url: SETTINGS.billing,
      active: false,
      visible: requireStripeAccount,
    },
  ]

  // Filter menu items to only show visible ones (DoubleNavbar doesn't handle visible property)
  const menuItems = allMenuItems.filter((item) => item.visible !== false)

  const handleLinkClick = (sideBarItem: SidebarItem) => {
    if (sideBarItem.url) {
      push(sideBarItem.url)
    }
  }

  const getHeaderControlsByRoute = () => {
    if (location.pathname === SETTINGS.orderset) {
      return <OrdersetListHeaderControls />
    } else if (location.pathname === SETTINGS.newOrderset) {
      return <CreateOrdersetHeaderControls />
    } else if (location.pathname.includes(SETTINGS.editOrderset.replace(':ordersetId', ''))) {
      return <EditOrdersetHeaderControls />
    } else if (location.pathname === SETTINGS.profile) {
      return <ProfileHeaderControls />
    } else if (location.pathname === SETTINGS.billing) {
      return <BillingHeaderControls />
    } else {
      return null
    }
  }

  return (
    <SettingsPageLayoutViewLayout>
      <ToolbarHeader title="Settings">{getHeaderControlsByRoute()}</ToolbarHeader>

      <ComponentLayout>
        <DoubleNavbar
          activeLink={menuItems.find((menuItem) => menuItem.url === location.pathname) ?? menuItems[0]}
          items={menuItems}
          handleLinkClick={handleLinkClick}
        />
        {props.children}
      </ComponentLayout>
    </SettingsPageLayoutViewLayout>
  )
}
